import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericTablePage from '../components/GenericTablePage';
import { GridColDef } from '@mui/x-data-grid';
import { formatDate } from '../lib/dateUtils';

const BoardMeetingsPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === 'ar' ? 'ar' : 'en';

  const columns: GridColDef[] = [
    { field: 'meeting_no', headerName: t('boardMeetings.meetingNo'), width: 120 },
    {
      field: 'date',
      headerName: t('boardMeetings.date'),
      width: 140,
      valueFormatter: (value) => formatDate(value, locale, 'medium'),
    },
    { field: 'location', headerName: t('boardMeetings.location'), flex: 1, minWidth: 180 },
    { field: 'attendees_count', headerName: t('boardMeetings.attendeesCount'), width: 130 },
  ];

  const fields = [
    { name: 'meeting_no', label: t('boardMeetings.meetingNo'), type: 'text' as const, required: true },
    { name: 'date', label: t('boardMeetings.date'), type: 'date' as const },
    { name: 'time', label: t('boardMeetings.time'), type: 'text' as const },
    { name: 'location', label: t('boardMeetings.location'), type: 'text' as const, width: 'half' as const },
    { name: 'attendees_count', label: t('boardMeetings.attendeesCount'), type: 'number' as const },
    { name: 'decisions_text', label: t('boardMeetings.decisions'), type: 'richtext' as const, width: 'full' as const },
    { name: 'source_url', label: t('boardMeetings.sourceUrl'), type: 'text' as const, width: 'full' as const },
  ];

  return (
    <GenericTablePage
      tableName="board_meetings"
      title={t('boardMeetings.title')}
      columns={columns}
      fields={fields}
    />
  );
};

export default BoardMeetingsPage;
